import React from 'react';
import { Navigate } from 'react-router-dom';

import { isAdminSignedIn } from '../utils/adminSession';

/**
 * Keeps the approval screens behind a staff sign-in.
 *
 * This is for the person, not for the data: the backend refuses these requests without a valid
 * sign-in whatever the page does, so a redirect here is a courtesy rather than the control.
 */
const AdminRoute = ({ children }) => (
    isAdminSignedIn() ? children : <Navigate to="/admin-login" replace />
);

export default AdminRoute;
